import Box from '@mui/material/Box';
import PaywallVerticalLayout from '../../../dashboard/paywall/sales-activated-trial/PaywallVerticalLayout';
import { ActionPaywallSource } from '../../../dashboard/paywall/paywallTypes';
import usePaywall from '../../../dashboard/paywall/usePaywall';
import { useRunOnceWhenTruthy } from '../../../common/useRunOnceWhenTruthy';

const DocumentationCardPaywallBlock = ({ objectName }: { objectName?: string }) => {
  const { isPaywallActive, sendEncounterPaywallEvent } = usePaywall();

  useRunOnceWhenTruthy(() => {
    sendEncounterPaywallEvent({ source: ActionPaywallSource.DEPENDENCIES, objectName });
  }, isPaywallActive);

  if (!isPaywallActive) {
    return null;
  }

  return (
    <Box
      sx={{
        height: '100%',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        padding: '24px',
      }}
    >
      <PaywallVerticalLayout paywallSource={ActionPaywallSource.DEPENDENCIES} variant="regular" />
    </Box>
  );
};

export default DocumentationCardPaywallBlock;
